import * as React from 'react';
import { BaSeLogoSebraeRestrict } from '../image/logo-sebrae/logo-sebrae-restrict';
import { BaSeSmall1 } from '../typography/small/small1';
import {
  SingleInfoWrapper,
  SingleSolutionGrid,
  SystemLogo,
  SystemLogoWrapper,
} from './single-solution-styled';
import { BaSeSmall2 } from '../typography/small/small2';
import { ButtonLink, Link } from './user-apps-styled';

export interface SingleSolutionProps {
  title: string;
  titleColor?: string;
  description: string;
  descriptionColor?: string;
  image?: string;
  link?: string;
  callback?(): void;
}

export interface InnerSingleSolutionProps extends SingleSolutionProps {
  isVisible: boolean;
  color: string;
  textColor?: string;
}

export const BaSeSingleSolution: React.FC<InnerSingleSolutionProps> = ({
  title = '',
  titleColor,
  description = '',
  descriptionColor,
  image = '',
  link = '',
  textColor,
  color,
  callback = () => {},
}) => {
  if (description.length > 70) {
    throw Error(
      '[BaSeSingleSolution] Atributo "description" deve ter no máximo "70 chars"',
    );
  }

  if (title.length > 30) {
    throw Error(
      '[BaSeSingleSolution] Atributo "title" deve ter no máximo "30 chars"',
    );
  }

  const titleRef = React.useRef<HTMLDivElement>(null);
  const descriptionRef = React.useRef<HTMLDivElement>(null);

  const renderSystemLogo = React.useCallback(
    () => (
      <SystemLogoWrapper className="BaSe--icon-user-apps">
        {image ? (
          <SystemLogo src={image} alt={title} />
        ) : (
          <BaSeLogoSebraeRestrict />
        )}
      </SystemLogoWrapper>
    ),
    [image, title],
  );

  const itemApps = React.useMemo(
    () => (
      <SingleSolutionGrid color={titleColor ?? color}>
        {renderSystemLogo()}
        <SingleInfoWrapper>
          <div ref={titleRef}>
            <BaSeSmall1 isBold={true} color={titleColor ?? color}>
              {title}
            </BaSeSmall1>
          </div>
          <div ref={descriptionRef}>
            <BaSeSmall2 color={descriptionColor ?? textColor}>
              {description}
            </BaSeSmall2>
          </div>
        </SingleInfoWrapper>
      </SingleSolutionGrid>
    ),
    [
      color,
      description,
      descriptionColor,
      renderSystemLogo,
      textColor,
      title,
      titleColor,
    ],
  );

  return link ? (
    <Link
      color={titleColor ?? color}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      tabIndex={0}
    >
      {itemApps}
    </Link>
  ) : (
    <ButtonLink
      role="button"
      tabIndex={0}
      color={titleColor ?? color}
      onClick={callback}
      onKeyDown={(event) => event.key === 'Enter' && callback()}
    >
      {itemApps}
    </ButtonLink>
  );
};

BaSeSingleSolution.displayName = 'BaSeSingleSolution';
